<div class="fiche-repondant-update">
  <m-spinner
    v-if="isLoadingStateActive"
    :title="true"
    :description="true"
    :processing="true"
    :title-message="$i18next.t('modules.fiche-repondant.update.FicheRepondantUpdate.loading_overlay.title')"
    :description-message="$i18next.t('modules.fiche-repondant.update.FicheRepondantUpdate.loading_overlay.description')"
  />
  <transition
    name="fade-fast"
    mode="out-in"
  >
    <template v-if="isSuccessStateActive">
      <div>
        <m-message
          class="fiche-repondant-update--success-message"
          :skin="MMessageSkin.Page"
          :title="$i18next.t('modules.fiche-repondant.update.FicheRepondantUpdate.message.update_success.title')"
        />
        <div class="fiche-repondant-update__footer">
          <m-button
            :skin="MButtonSkin.Secondary"
            @click="onReturnHomeButtonClick"
          >
            {{ $i18next.t('modules.fiche-repondant.update.FicheRepondantUpdate.button.return_home.label') }}
          </m-button>
        </div>
      </div>
    </template>
    <template v-else>
      <div>
        <transition
          name="fade-fast"
          mode="out-in"
        >
          <template v-if="ficheRepondant">
            <div>
              <fiche-repondant-form
                :ref="REF_FICHE_REPONDANT_FORM"
                :fiche-repondant="ficheRepondant"
              />
              <div class="fiche-repondant-update__footer">
                <m-button @click="onSubmitButtonClick">
                  {{ $i18next.t('modules.fiche-repondant.update.FicheRepondantUpdate.button.submit.label') }}
                </m-button>
                <m-button
                  :skin="MButtonSkin.Secondary"
                  @click="onReturnHomeButtonClick"
                >
                  {{ $i18next.t('modules.fiche-repondant.update.FicheRepondantUpdate.button.return_home.label') }}
                </m-button>
              </div>
            </div>
          </template>
        </transition>
      </div>
    </template>
  </transition>
</div>